import React from "react";
import "./index.css";
import cn from "classnames";
import BgTransformer from "../../../layout/BgTransformer";
import Textarea from "../../../layout/Textarea/Textarea";
import ContentEditable from "../../../layout/ContentEditable/ContentEditable";
import ImageUpload from "../../../layout/ImageUpload";
import PixelationLayer from "../../../layout/PixelationLayer";
import {useSetting} from "../../../contexts/setting";
import {useBgUrl} from "hooks/useBgUrl";
import {useEdits} from "../../../contexts/edits";
import {checkIfIDE} from "../../../data/products/index";
import {useLogoUrl} from "../../../hooks/useLogoUrl";

const Splash2x = ({id, zoom}) => {
  const {product, type, channel, layoutOption} = useSetting();
  const {url: bgUrl} = useBgUrl();
  const {subtitles, productNames} = useEdits();

  // Map Figma slots to React state
  const defaultProductName = product.altLabel || product.label;
  const productName = productNames[id] || productNames.main || defaultProductName;
  const subtitle = subtitles[id] ?? subtitles.main ?? "";
  const logoSrc = useLogoUrl(id);
  const logoClass = cn("logo", {ide: checkIfIDE(product.value, type.value)});

  return (
    <div
      id={id}
      className={cn("template", product.value, "release-splash2x", `layout-${layoutOption}`)}
      style={{"--zoom-level": zoom}}
    >
      <div>
        <BgTransformer src={bgUrl} id={id} />
        {/* 2× tiles: this is the @2x variant on a doubled canvas, so match the
            base Splash mosaic's visual square size instead of rendering half-size. */}
        <PixelationLayer scale={2} />
        <div className="content">
          <div className="product-name">
            <ContentEditable id={id} text={productName} />
          </div>
          <div className="title-wrap">
            <div className="subtitle">
              <Textarea id={id} text={subtitle} />
            </div>
          </div>
          <header className="template-header">
            <div className={logoClass}>
              <img src={logoSrc} alt="logo" />
            </div>
          </header>
        </div>
        {[5, 6].includes(+layoutOption) && (
          <div className="upload-wrap">
            <ImageUpload id={id} />
          </div>
        )}
      </div>
    </div>
  );
};

export default Splash2x;
